export const getDyConsentAccepted = (): boolean => {
    if (typeof document === 'undefined') return false
    const cookieStr = document.cookie || ''
    const cookieMap = cookieStr.split(';').reduce(
        (acc, entry) => {
            const [key, ...valArr] = entry.trim().split('=')
            acc[key] = valArr.join('=')
            return acc
        },
        {} as Record<string, string>,
    )

    if (!cookieMap.OptanonConsent) return false
    const optanon = decodeURIComponent(cookieMap.OptanonConsent)
    const groupsMatch = optanon.match(/groups=([^&]+)/)
    if (!groupsMatch) return false
    const groupsArray = groupsMatch[1].split(',')
    const consentCategoryGroup = groupsArray.find((group) => group.indexOf('C0004:') === 0)
    if (!consentCategoryGroup) return false
    return consentCategoryGroup.split(':')[1] === '1'
}
